import React from "react";

export const inlineArrow = (
  <svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5.6252L0.625 1.2502L1.2375 0.637695L5 4.4002L8.7625 0.637695L9.375 1.2502L5 5.6252Z" />
  </svg>
);
